import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import axiosClient from '@lib/utils/axiosClient';

import { showMessage } from 'actions';

import { FileUpload } from '../types';

type Data = { file?: File; fileBase64?: string; name: string; extension: string; type?: string; contentType?: string };
type Response = FileUpload;

const mutationFn = async (data: Data) => {
  const formData = new FormData();
  if (data.file) {
    formData.append('file', data.file);
  } else if (data.fileBase64) {
    // Convert Base64 String to javascript file object
    // https://stackoverflow.com/a/62432112/12993819
    const res = await fetch(data.fileBase64);
    const blob = await res.blob();
    const file = new File([blob], data.name, { type: `image/${data.extension}` });
    formData.append('file', file);
  }

  formData.append('name', data.name);
  formData.append('extension', data.extension);

  if (data.type) {
    formData.append('type', data.type);
  }

  if (data.contentType) {
    formData.append('contentType', data.contentType);
  }

  const response = await axiosClient.post('/fileUploads/binary', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data as Response;
};

export default function useFileUploadCreateOne() {
  const dispatch = useDispatch();

  const mutation = useMutation(mutationFn, {
    // TODO: Make errors management generic to all `react-query` mutations
    onError: (error: Error) => {
      dispatch(showMessage(get(error, 'message'), 'error'));
    },
  });

  return mutation;
}
